import {
  Box,
  Card,
  Container,
  Grid,
} from '@mui/material';
import ViewDocsResult from './ViewDocsResult'
import ViewDocsToolbar from './ViewDocsToolBar';
import { useState } from 'react';

const ViewDocs = () => {
  const [invoiceUrl, setInvoiceUrl] = useState([]);
  const [prescriptionUrl, setPrescriptionUrl] = useState([]);
  const [reportUrl, setReportUrl] = useState([])
  const [message, setMessage] = useState("")

  const handleResponse = (res) => {
    if (res.isSuccess) {
      setPrescriptionUrl(res.files.prescriptionUrl);
      setReportUrl(res.files.reportUrl);
      setInvoiceUrl(res.files.invoiceUrl);
      setMessage("")
    } else {
      setPrescriptionUrl([]);
      setReportUrl([]);
      setInvoiceUrl([]);
      setMessage("No documents found or Invalid request id");
    }
  }

  return (
    <>
      <Box sx={{ backgroundColor: 'background.default', py: 2 }}>
        <Grid item sx={{ marginLeft: 3 }}>
          <ViewDocsToolbar
            invoiceUrl={invoiceUrl}
            prescriptionUrl={prescriptionUrl}
            reportUrl={reportUrl}
            handleResponse={handleResponse}
          />
        </Grid>
      </Box>
      <Container maxWidth={false}>
        {
          (invoiceUrl.length > 0 || prescriptionUrl.length > 0 || reportUrl.length > 0 || message) &&
          <Grid container>
            <Grid item xs={12}>
              <Card
                sx={{
                  width: '100%',
                  borderRadius: 4,
                  mb: 2,
                  p: 3,
                  boxShadow: '0 0 16px 0 rgba(0, 0, 0, 0.06)'
                }}
              >
                <ViewDocsResult
                  invoiceUrl={invoiceUrl}
                  prescriptionUrl={prescriptionUrl}
                  reportUrl={reportUrl}
                  message={message}
                />
              </Card>
            </Grid>
          </Grid>
        }
      </Container>

    </>
  );
};

export default ViewDocs;
